"use client";
import React, { useEffect, useState } from "react";
import "./CircleCursor.css";

export default function CircleCursor() {
  const [point, setPoint] = useState({ x: -100, y: -100 });
  const [circle, setCircle] = useState({ x: -100, y: -100 });
  const [hovering, setHovering] = useState(false);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const isFinePointer = window.matchMedia("(pointer: fine)").matches;
    setEnabled(isFinePointer);
    if (!isFinePointer) return;

    let circlePos = { x: -100, y: -100 };
    let target = { x: -100, y: -100 };
    let frame = 0;

    const handleMouseMove = (e) => {
      target = { x: e.clientX, y: e.clientY };
      setPoint(target);
    };

    const animate = () => {
      circlePos = {
        x: circlePos.x + (target.x - circlePos.x) * 0.18,
        y: circlePos.y + (target.y - circlePos.y) * 0.18,
      };
      setCircle({ ...circlePos });
      frame = requestAnimationFrame(animate);
    };

    const handlePointerOver = (e) => {
      const interactive = e.target.closest(
        "a, button, input, textarea, select, [role='button']"
      );
      setHovering(Boolean(interactive));
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("pointerover", handlePointerOver);
    frame = requestAnimationFrame(animate);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("pointerover", handlePointerOver);
      cancelAnimationFrame(frame);
    };
  }, []);

  if (!enabled) return null;

  return (
    <>
      <div
        className={`circle-cursor${hovering ? " is-hovering" : ""}`}
        style={{ left: `${circle.x}px`, top: `${circle.y}px` }}
      />
      <div
        className={`circle-cursor-point${hovering ? " is-hovering" : ""}`}
        style={{ left: `${point.x}px`, top: `${point.y}px` }}
      />
    </>
  );
}
